import { render, staticRenderFns } from "./ed-viewer-write-object.vue?vue&type=template&id=c8aed242&scoped=true&"
import script from "./ed-viewer-write-object.ts?vue&type=script&lang=ts&"
export * from "./ed-viewer-write-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-viewer-write-object.scss?vue&type=style&index=0&id=c8aed242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8aed242",
  null
  
)

export default component.exports